var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLocationMap = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.8332C10.834 14.6665 16.6673 14.1817 16.6673 8.83317C16.6673 5.15127 13.6825 2.1665 10.0007 2.1665C6.31875 2.1665 3.33398 5.15127 3.33398 8.83317C3.33398 14.1817 9.16732 14.6665 10.0007 18.8332Z",
    stroke: "#7E7E80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 11.3332C11.3814 11.3332 12.5007 10.2139 12.5007 8.83317C12.5007 7.45246 11.3814 6.33317 10.0007 6.33317C8.61994 6.33317 7.50065 7.45246 7.50065 8.83317C7.50065 10.2139 8.61994 11.3332 10.0007 11.3332Z",
    stroke: "#7E7E80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location-map.c9bfbef0.svg";
export { ForwardRef as ReactComponent };